var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlimitedInternet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 43,
    fill: "white",
    stroke: "#F68140",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1055 58.97C56.4416 58.97 52.0887 56.7935 49.2903 53.2178L40.429 44.201L49.4458 35.3396C54.2652 28.8101 63.5929 27.5664 70.1224 32.3858C76.6518 37.2051 77.8955 46.5329 73.0762 53.0624C70.1224 56.7935 65.7694 58.97 61.1055 58.97ZM60.9501 35.3396C58.1517 35.3396 55.5089 36.5833 53.7988 38.7598L48.3576 44.201L53.7988 49.4867C55.5089 51.6632 58.1517 53.0624 60.9501 52.9069C65.7694 52.9069 69.8115 49.0203 69.8115 44.0455C69.8115 39.3816 65.9249 35.3396 60.9501 35.3396Z",
    fill: "#F68140"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4961 53.0624C34.5213 59.5919 25.349 60.8356 18.8195 55.8607C12.2901 50.8859 11.0464 41.7136 16.0212 35.1842C20.996 28.6547 30.1683 27.411 36.6978 32.3858C37.786 33.1631 38.7188 34.0959 39.4961 35.1842L48.513 44.0456L39.4961 53.0624ZM34.9877 38.9153C33.2776 36.7388 30.6347 35.3396 27.8364 35.4951C23.017 35.4951 18.975 39.3817 18.975 44.3565C18.975 49.3313 22.8616 53.2179 27.8364 53.2179C30.6347 53.2179 33.2776 51.9742 34.9877 49.7977L40.4289 44.5119L34.9877 38.9153Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlimitedInternet);
export default __webpack_public_path__ + "static/media/unlimited_internet.408f86666e871db9fd7743688a3881af.svg";
export { ForwardRef as ReactComponent };